module.exports = {
  utmSource: 'utm_source',
  utmTactic: 'utm_tactic',
  utmTerm: 'utm_term',
  utmCampaign: 'utm_campaign',
};
